module.exports = __webpack_public_path__ + "static/media/singapore.1fa623c2.gif";